<template>

    <div class="module-editor">
        
        <Disclaimer v-if="courseStatus == 'A1'"/>
        
        <template v-if="route.query.type">
            <h3 style="text-align:center; margin-bottom:20px; font-size:21px">{{ t('moduleEditor.STUDENT_PRACTICE') }}</h3>
            <div class="select-finalPractice">
                <Select 
                    v-model="finalPractice.type"
                    mode="simple"
                    id="selectFinalPractice"
                    :label="t('moduleEditor.PRACTICE_TYPE')"
                    valueProp="id"
                    valueLabel="name"
                    :values="finalPractice.types"
                    :isDropdown="true"
                    @update:modelValue="type => replaceQuery(type)"
                    :style="{opacity: courseStatus == 'A1' ? 0.5 : 1, cursor: courseStatus == 'A1' ? 'not-allowed' : 'pointer'}"
                />
            </div>
        </template>

        <div v-else class="config-portada">
            <span 
                @click="orderActive ? '' : modalContent.showModal = 'PORTADA'"
                :class="{'disabled' : orderActive}"
            >
                {{ t('moduleEditor.CONFIGURATION') }}<i class="material-icons">settings</i>
            </span>
        </div>

        <VisibleModal v-if="modalContent.showModal || modalRemoveContent.id || modalAddContent"/>

        <render-module
            ref="renderModuleRef"
            :moduleId="route.params.moduleId" 
            :editMode="true"
            :finalPractice="route.query.type"
            :status="route.query.s"
            @editContent="(content) => editContent(content)"
            @addContent="(orderNumber) => modalAddContent = parseInt(orderNumber)+1"
            @removeContent="(content) => modalRemoveContent.id = content.id"
            @hasPortada="(id)=> {portada.hasPortada = true; portada.contentId = id}"
            @orderActive="(active)=> orderActive = active"
        />

        <ConfigPortada v-if="modalContent.showModal == 'PORTADA'"
            :hasPortada="portada.hasPortada"
            :contentId="portada.contentId"
            :status="courseStatus"
            @close="modalContent.showModal=false"
            @reload="reloadModule()"
        />

        <HTMLEditor v-if="modalContent.showModal == 'HTML'"
            :content="modalContent.content"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />

        <GeniallyEditor v-if="modalContent.showModal == 'GENIALLY'"
            :content="modalContent.content"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />

        <ForumActivityEditor v-if="modalContent.showModal == 'FORUM' || modalContent.showModal == 'ATTACH'"
            :content="modalContent.content"
            :status="courseStatus"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />

        <ContentShareEditor  v-if="modalContent.showModal == 'CONTENTSHARE'" 
            :content="modalContent.content"
            :isPublished="courseStatus == 'A1'"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />

        <TripEditor  v-if="modalContent.showModal == 'TRIP'" 
            :content="modalContent.content"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />
        
        <CommentsWall v-if="modalContent.showModal == 'COMMENTSWALL'" 
            :content="modalContent.content"
            :status="courseStatus"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />

        <ImageEditor v-if="modalContent.showModal == 'IMAGEN'" 
            :content="modalContent.content"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />

        <Shortcut v-if="modalContent.showModal == 'ACCESO_DIRECTO'"
            :content="modalContent.content"
            :status="courseStatus"
            @close="modalContent.showModal = false"
            @reload="reloadModule()"
        />


        <create-content
            :finalPractice="route.query.type"
            @create="(content) => editContent(content,true)"
            v-if="courseStatus !== 'A1'"
        />

    </div> <!-- End .module-editor -->

    <div class="modal__overlay" v-if="modalRemoveContent.id">
        <div class="modal-removeContent">
            <strong>{{ t('moduleEditor.CONFIRM_DELETE_CONTENT') }}</strong>
            <span>{{ t('moduleEditor.DELETE_WARNING') }}</span>
            <div class="modal__buttons">
                <button class="cancel" @click.stop="modalRemoveContent.id = null" :disabled="modalRemoveContent.posting">{{ t('global.CANCEL') }}</button>
                <button class="confirm" @click.stop="removeContent()" :disabled="modalRemoveContent.posting">{{ t('global.DELETE') }}</button>
            </div>
        </div>
    </div>

    <div class="modal__overlay" v-if="modalAddContent">
        <div class="modal-addContent">
            <i class="material-icons close" @click.stop="modalAddContent = null">close</i>
            <create-content
                :order="modalAddContent" 
                :finalPractice="route.query.type"
                @create="(content) => editContent(content,true)"
            />
        </div>
    </div>

</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import Select from '@/components/Inputs/Select.vue';
import VisibleModal from '@/components/VisibleModal.vue';
import RenderModule from '@/views/Contents/RenderModule.vue';
import CreateContent from './EditorComponents/CreateContent.vue';
import ConfigPortada from './EditorComponents/Portada.vue';
import HTMLEditor from './EditorComponents/HTML.vue';
import CommentsWall from './EditorComponents/CommentsWall.vue';
import GeniallyEditor from './EditorComponents/Genially.vue';
import ForumActivityEditor from './EditorComponents/ForumActivity.vue';
import ContentShareEditor from './EditorComponents/ContentShare.vue';
import TripEditor from './EditorComponents/Trip.vue';
import ImageEditor from './EditorComponents/Image.vue';
import Disclaimer from '@/views/Contents/MastersCourses/Disclaimer.vue';
import Shortcut from './EditorComponents/Shortcut.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();

// save route.query.s
const courseStatus = ref(route.query.s);
watch(() => route.query.s, (newStatus) => {
    courseStatus.value = newStatus;
});


const finalPractice = ref({
    type: route.query.type,
    types: [
        {
            id: 'Trip',
            name: 'TRIP'
        },
        {
            id: 'ContentShare',
            name: 'Práctica situada'
        }
    ]
})

const replaceQuery = (type) =>{
    router.push({ query: { type: type } })
}

const renderModuleRef = ref(null);
const orderActive = ref(false);
const portada = ref({
    hasPortada: false,
    contentId: null
});

const modalContent = ref({
    content: null,
    showModal: false
});

const modalAddContent = ref(null);

const modalRemoveContent = ref({
    id: null,
    posting: false
})


function editContent(content, createNew = false) {
    // Always include courseCfgId
    content.courseCfgId = route.params.courseCfgId;

    if (createNew) {
        content.moduleCfgId = route.params.moduleId;
        modalAddContent.value = null;
        if (content.htmlType == 'DIVISION') {
            createDivision(content);
            return;
        }
    }

    modalContent.value.content = content;
    if (content.type.toUpperCase() == 'HTML') {
        if (content.htmlType.toUpperCase() == 'ENUNCIADO' || content.htmlType.toUpperCase() == 'GENERICO') {
            modalContent.value.showModal = 'HTML';
        }
        else { modalContent.value.showModal = content.htmlType.toUpperCase() }
    } else {
        modalContent.value.showModal = content.type.toUpperCase();
    }
}


async function removeContent(){
    modalRemoveContent.value.posting = true;
    try {
        await store.dispatch('contentEditor_removeContent', {courseCfgId: route.params.courseCfgId, contentId: modalRemoveContent.value.id});
        modalRemoveContent.value.id = null;
        reloadModule();
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', { text: t('moduleEditor.ERROR_DELETING_CONTENT') })
    } finally {
        modalRemoveContent.value.posting = false;
    }    
}

async function createDivision(model){
    //modalAddContent.value = null;
    // model.data.Data = '<div style="width:100%; height:30px; display:flex; justify-content:center; align-items:center"><div style="width:98%; height:4px; background-color:#009696; border-radius:12px"></div></div>';
    model.data.Data = `
    <div style="margin: 20px 0 15px 0; height: auto;">
      <div style="width: 100%; height: auto;">
        <div style="width: 100%; height: 84px; background: transparent; position: relative; overflow: hidden; border-radius: 0;">
          <div style="
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            background: rgba(125, 125, 125, 0.5);
            box-shadow: 0 4px 4px 1px rgba(125, 125, 125, 0.15);
          "></div>
        </div>
      </div>
    </div>
  `;
    await store.dispatch('contentEditor_createContent', model);
    reloadModule();
}

const reloadModule = async() => {
    modalContent.value.showModal = false;
    let scrollPosition = window.scrollY;
    portada.value.hasPortada = false;
    portada.value.contentId = null;
    await renderModuleRef.value.getModule(route.params.moduleId);
    window.scrollTo(0, scrollPosition);
};


</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import '/EditorComponents/commonStyles.scss';

.module-editor{
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 24px;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    .select-finalPractice{
        width: 260px;
        margin-bottom: 16px;
        align-self: center;
    }
    .config-portada{
        padding: 0 8px 22px 0;
        display: flex;
        justify-content: flex-end;
        span{
            padding: 6px 18px;
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: $darkgray;
            border: 1px solid $darkgray;
            border-radius: 18px;
            cursor: pointer;
            .material-icons{
                font-size: 16px;
            }
            &.disabled{
                opacity: .6;
                cursor: default;
            }
        }
    }
}

.modal__overlay{
    z-index: 1 !important;
}

.modal-addContent{
    @include componentModal;
    width: fit-content;
    max-width: 98vw;
}

.modal-removeContent{
    @include componentModal;
    max-width: 470px;
    span, strong {
        display: block;
        text-align: center;
    }
    span {
        font-weight: 500;
    }
    strong{
        margin: 12px 0 18px 0;
    }
    .confirm{
        background: $red;
    }
}

.edit-order-mode + .create-content{
    display:none;
}



</style>
